import { FinancialWorkspacePermissionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface FWPermissions {
  canManageLaborCost: boolean
  canSeeExpenses: boolean
  canSeeCompensations: boolean
  canSeePayroll: boolean
}

export const usePermissions = (): { permissions: FWPermissions; loading: boolean } => {
  const { data, loading } = useQuery(FinancialWorkspacePermissionsDocument, {
    fetchPolicy: 'network-only',
  })

  const payrollPolicies = data?.payroll._policies
  const financialWorkspacePolicies = data?.financialWorkspace._policies

  return {
    permissions: {
      canManageLaborCost: !!payrollPolicies?.conceptsManageLaborCost?.can,
      canSeeExpenses: !!financialWorkspacePolicies?.expensesSee?.can,
      canSeeCompensations: !!financialWorkspacePolicies?.compensationsSee?.can,
      canSeePayroll: !!financialWorkspacePolicies?.payrollSee?.can,
    },
    loading,
  }
}
